export const SET_CURRENT_CITY_TO_CITY_RIDE_CATEGORIES = 'SET_CURRENT_CITY_TO_CITY_RIDE_CATEGORIES';

export const actionSetCurrentCityToCityRideCategories = rideCategories => ({
    type: SET_CURRENT_CITY_TO_CITY_RIDE_CATEGORIES,
    payload: rideCategories
})